module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload",
    attrs: {
      "action": _vm.action,
      "on-success": _vm.uploadSuccess,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("select file")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("upload to server")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("Upload product excel files")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.navigate({
          name: 'product.new'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('product.create')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('base.deleteConfirm'),
      "size": "tiny"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('product.deleteConfirmText')) + " " + _vm._s(_vm.selectedProduct.name))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.deleteSelectedProduct()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.confirm')))])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.products,
      "border": "border"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('p', [_vm._v(_vm._s(_vm.$t('product.price')) + " : " + _vm._s(_vm._f("currency")(props.row.price, '฿')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('product.extraDescription')) + " : " + _vm._s(props.row.description))])])], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('product.refCode'),
      "property": "refCode",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('product.category'),
      "property": "category",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('product.size'),
      "property": "size",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('product.name'),
      "property": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('product.type'),
      "property": "productType",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-dropdown', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "trigger": "click",
            "size": "small"
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('i', {
          staticClass: "el-icon-more"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.navigate({
                name: 'product.edit',
                params: {
                  id: _vm.products[scope.$index].id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.edit')))]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.confirmDelete(_vm.products[scope.$index])
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.delete')))])], 1)], 1)]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "10px 0px",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c08f2ba"}!./src/pages/product/view/index.html
// module id = 805
// module chunks = 1